import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxsModule } from '@ngxs/store';

import { CoreState } from './store/core.state';

@NgModule({
    declarations: [],
    imports: [CommonModule, NgxsModule.forFeature([CoreState])]
})
export class CoreModule {}

export * from './services/office-privileges-provider.service';
export * from './services/office-security.service';
export * from './services/week-day.service';
export * from './services/download-file.service';
export * from './services/signal-r.service';
export * from './services/court-booking-hub.service';
export * from './services/groupclass-autologin-provider.service';

export * from './resolvers/context-resolver.service';
export * from './store/core.facade';
export * from './store/core.state';
export * from './resolvers/courts-resolver.service';

export { SelectedClubChangedSuccess } from './store/core.actions';
